import HtmlElement from '../../../../Js/Elements/HtmlElement';

/**
 * Countdown
 */
const Countdown = (() => {
	/**
	 * Selector
	 *
	 * @var { Object }
	 */
	const Selector = {
		DAYS: '.scarcity-countdown-days',
		HOURS: '.scarcity-countdown-hours',
		MINUTES: '.scarcity-countdown-minutes',
		SECONDS: '.scarcity-countdown-seconds',
		WRAP: '.scarcity-wrap',
		FINISHED: '.scarcity-finished'
	};

	/**
	 * Countdown
	 *
	 * @class
	 * @augments HtmlElement
	 */
	class Countdown extends HtmlElement {
		// Public

		/**
		 * Handles ready event
		 *
		 * @return void
		 */
		onReady() {
			super.onReady();

			this._$days = this.$element.find(Selector.DAYS);
			if (this._$days.length) {
				this._$daysValue = this._$days.find('> span');
			}

			this._$hours = this.$element.find(Selector.HOURS);
			if (this._$hours.length) {
				this._$hoursValue = this._$hours.find('> span');
			}

			this._$minutes = this.$element.find(Selector.MINUTES);
			if (this._$minutes.length) {
				this._$minutesValue = this._$minutes.find('> span');
			}

			this._$seconds = this.$element.find(Selector.SECONDS);
			if (this._$seconds.length) {
				this._$secondsValue = this._$seconds.find('> span');
			}

			if (this._$days.length || this._$hours.length || this._$minutes.length || this._$seconds.length) {
				this._endDate = this.$element.data('end');
				this._initialize();
			}
		}

		// Private

		_initialize() {
			this._updateDigits();
			this.$element.addClass('initialized');

			this.countdown = setInterval(() => {
				this._updateDigits();
			}, 1000);
		}

		_updateDigits() {
			const now = new Date().getTime();
			const t = this._endDate - now;

			if (t >= 0) {
				if (this._$days.length) {
					const days = Math.floor(t / (1000 * 60 * 60 * 24));
					this._$days.toggleClass('is-singular', days === 1);
					this._$daysValue.html(`0${days}`.slice(-2));
				}

				if (this._$hours.length) {
					const hours = Math.floor((t % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
					this._$hours.toggleClass('is-singular', hours === 1);
					this._$hoursValue.html(`0${hours}`.slice(-2));
				}

				if (this._$minutes.length) {
					const minutes = Math.floor((t % (1000 * 60 * 60)) / (1000 * 60));
					this._$minutes.toggleClass('is-singular', minutes === 1);
					this._$minutesValue.html(`0${minutes}`.slice(-2));
				}

				if (this._$seconds.length) {
					const seconds = Math.floor((t % (1000 * 60)) / 1000);
					this._$seconds.toggleClass('is-singular', seconds === 1);
					this._$secondsValue.html(`0${seconds}`.slice(-2));
				}
			} else {
				clearInterval(this.countdown);
				this._countdownEnded();
			}
		}

		_countdownEnded() {
			this._$wrap = this.$element.parent(Selector.WRAP);
			this._$finished = this._$wrap.next(Selector.FINISHED);

			this._$wrap.fadeOut(300, () => {
				this._$finished.fadeIn(300);
			});
		}
	}

	return Countdown;
})();

export default Countdown;
